(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["yayaah-pair-offer"] && !Shopify.designMode) return;
  try {
    class StarryPairOffer extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.root = this.closest('.shopify-section');
    this.details = this.closest('.product-details');
    this.variants = JSON.parse(this.querySelector('[data-set-variants]').textContent);
    this.labels = JSON.parse(this.querySelector('[data-set-labels]').textContent);
    this.selected = Number(this.querySelector('input[type="radio"]:checked')?.value) || 2;
    this.details?.classList.add('starry-set-active');
    const options={signal:this.controller.signal};
    this.addEventListener('change',event=>{
      if (!event.target.matches('input[type="radio"]')) return;
      this.selected=Number(event.target.value);
      this.applyQuantity();
      this.refresh();
    },options);
    this.root.addEventListener('shopify:product:select',async event=>{
      try {
        const {detail}=await event.promise;
        if (!this.isConnected) return;
        this.dataset.variantId=String(detail?.resource?.id||'');
        queueMicrotask(()=>{if(this.isConnected){this.applyQuantity();this.refresh();}});
      } catch {}
    },options);
    this.root.addEventListener('quantity-selector:update',()=>this.render(),options);
    window.addEventListener('focus',()=>this.refresh(),options);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)this.refresh();},options);
    queueMicrotask(()=>{if(this.isConnected){this.applyQuantity();this.refresh();}});
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.request?.abort();
    this.details?.classList.remove('starry-set-active');
  }
  get quantity(){return this.root?.querySelector('.product-details input[name="quantity"]');}
  get variantId(){return this.root?.querySelector('.product-details input[name="id"]')?.value||this.dataset.variantId;}
  applyQuantity() {
    const input=this.quantity;
    const component=this.root.querySelector('.product-details quantity-selector-component');
    if(!input) return;
    const variant=this.variants[this.variantId];
    if(variant?.stock!==null&&variant?.stock<this.selected)this.selected=1;
    input.value=String(this.selected);
    if(component?.initialized){
      component.onQuantityChange();
      component.updateButtonStates();
    }
    input.dispatchEvent(new Event('change',{bubbles:true}));
    this.render();
  }
  format(amount,currency=this.dataset.currency){
    return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency,currencyDisplay:'code'}).format(amount);
  }
  render() {
    const id=this.variantId,variant=this.variants[id];
    if(!variant)return;
    const quotes=this.quoteVariant===id?this.quotes:null;
    for(const option of this.querySelectorAll('.starry-set__option')){
      const radio=option.querySelector('input'),quantity=Number(radio.value),quote=quotes?.[quantity];
      radio.checked=quantity===this.selected;
      radio.disabled=!variant.available||(variant.stock!==null&&variant.stock<quantity);
      const original=option.querySelector('[data-original]'),badge=option.querySelector('[data-badge]');
      const saving=quote?Math.max(0,quote.original-quote.total):0;
      original.hidden=!saving;
      badge.hidden=!saving;
      if(saving){
        original.textContent=this.format(quote.original/quantity,quote.currency);
        badge.textContent=this.labels.off.replace('[percent]',new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:1}).format(saving/quote.original*100));
      }
      option.querySelector('[data-price]').textContent=radio.disabled?this.labels.unavailable:this.labels.per_glass.replace('[amount]',quote?this.format(quote.total/quantity,quote.currency):this.format(variant.unit/100));
    }
    const selected=quotes?.[this.selected];
    this.querySelector('[data-total]').textContent=selected?this.format(selected.total,selected.currency):this.format(variant.unit*this.selected/100);
    let text=this.failed||(quotes&&!selected)?this.labels.failed:this.labels.loading;
    if(selected){
      const saved=Math.max(0,selected.original-selected.total);
      text=saved?this.labels.saving.replace('[amount]',this.format(saved,selected.currency)).replace('[percent]',new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:1}).format(saved/selected.original*100)):this.selected===1?this.labels.single:this.labels.no_discount;
      if(this.selected>1)text+=' '+this.labels.colour;
    }
    this.querySelector('[data-offer]').textContent=text;
  }
  async refresh() {
    const id=this.variantId;
    if(!this.variants[id])return;
    if(this.pendingId===id)return;
    this.request?.abort();
    const request=new AbortController();
    this.request=request;
    this.pendingId=id;
    this.failed=false;
    if(this.quoteVariant!==id)this.quotes=null;
    this.render();
    const timeout=setTimeout(()=>request.abort(),10000);
    try {
      const fields='cart{lines(first:1){nodes{quantity cost{subtotalAmount{amount currencyCode} totalAmount{amount currencyCode}}}pageInfo{hasNextPage endCursor}}}userErrors{field message}';
      const query='mutation StarrySetQuotes($variant:ID!,$country:CountryCode!) @inContext(country:$country){'+[1,2,4].map(quantity=>'q'+quantity+':cartCreate(input:{buyerIdentity:{countryCode:$country},lines:[{merchandiseId:$variant,quantity:'+quantity+'}]}){'+fields+'}').join(' ')+'}';
      const response=await fetch('/api/2026-10/graphql.json',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({query,variables:{variant:'gid://shopify/ProductVariant/'+id,country:this.dataset.country}}),signal:request.signal,credentials:'omit',cache:'no-store'});
      if(!response.ok)throw new Error('Quote unavailable');
      const result=await response.json();
      if(result.errors?.length)throw new Error('Quote unavailable');
      const quotes={};
      for(const quantity of [1,2,4]){
        const payload=result.data?.['q'+quantity],line=payload?.cart?.lines?.nodes?.[0];
        if(payload?.userErrors?.length||!line||line.quantity!==quantity||payload.cart.lines.pageInfo.hasNextPage)continue;
        const currency=line.cost.totalAmount.currencyCode;
        if(currency!==this.dataset.currency)throw new Error('Currency mismatch');
        const original=Number(line.cost.subtotalAmount.amount),total=Number(line.cost.totalAmount.amount);
        if(!Number.isFinite(original)||!Number.isFinite(total))continue;
        quotes[quantity]={original,total,currency};
      }
      if(!quotes[1])throw new Error('Quote unavailable');
      if(this.request!==request||!this.isConnected||this.variantId!==id)return;
      this.quoteVariant=id;
      this.quotes=quotes;
    } catch {
      if(this.request===request){this.failed=true;this.quotes=null;}
    } finally {
      clearTimeout(timeout);
      if(this.request===request){this.pendingId=null;if(this.isConnected)this.render();}
    }
  }
}
if(!customElements.get('starry-pair-offer'))customElements.define('starry-pair-offer',StarryPairOffer);
  } catch(e) { console.error(e); }
})();

})();
